<template>
  <div
    ref="alert"
    :class="['message with-icon', customClass]"
    :style="componentStyle"
  >
    <font-awesome-icon
      :icon="$v6[iconStyle][iconName]"
      fixed-width
      :class="['decorative', iconClass]"
    />
    <h4 class="title">
      <slot />
    </h4>
    <slot name="message" />
  </div>
</template>
<script>
  export default {
    name: 'Alert',

    props: {
      customClass: {
        type: String,
        default: ''
      },

      customStyle: {
        type: Object,
        default: () => {}
      },

      iconClass: {
        type: String,
        default: ''
      },

      iconStyle: {
        type: String,
        default: 'solid'
      },

      iconName: {
        type: String,
        default: 'faCircleInfo'
      },

      replace: {
        type: Object,
        default() {
          return {}
        }
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    },

    mounted() {
      this.doReplacements()
    },

    methods: {
      doReplacements() {
        const replaceKeys = Object.keys(this.replace)
        const alert = this.$refs.alert

        const r = (node) => {
          ;[...node.childNodes].forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
              replaceKeys.forEach((k) => {
                child.nodeValue = child.nodeValue.replace(k, this.replace[k])
              })
            }
            r(child)
          })
        }

        r(alert)
      }
    }
  }
</script>
